import { InputBase, makeStyles } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import hexToRGBA from '~utils/hex-to-rgba';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.body1,
    color: theme.colors.dark,
    borderRadius: theme.borderRadius.small,
    border: `1px solid ${theme.colors.greyCc}`,
    overflow: 'hidden',
    backgroundColor: theme.colors.white,

    '&$error:not($disabled)': {
      border: `1px solid ${theme.colors.red}`,
    },

    '&$error:not($disabled):hover': {
      backgroundColor: hexToRGBA(theme.colors.redBg, 0.32),
    },

    '&:not($error):not($disabled):hover': {
      backgroundColor: theme.colors.greyFa,
    },

    '&$disabled': {
      backgroundColor: theme.colors.greyF7,
      border: `solid 1px ${theme.colors.greyE8}`,
      WebkitOpacity: '1',
      WebkitTextFillColor: theme.colors.grey99 /* Override iOS / Android font color change */,
      color: theme.colors.grey99,
      '& svg': {
        fill: theme.colors.grey99,
      },
    },
  },
  formControl: {},
  focused: {
    border: `solid 1px ${theme.colors.brandAction}`,
    boxShadow: `0 0 4px 0 ${hexToRGBA(theme.colors.brandAction, 0.64)}`,

    '&$error': {
      border: `solid 1px ${theme.colors.red}`,
      boxShadow: `0 0 4px 0 ${hexToRGBA(theme.colors.red, 0.64)}`,
    },
  },
  disabled: {},
  adornedStart: {},
  adornedEnd: {},
  error: {},
  marginDense: {},
  multiline: {
    padding: 0,
    paddingBottom: 32,
  },
  colorSecondary: {},
  fullWidth: {},
  input: {
    flex: 1,
    padding: '7px 12px 7px 12px',
    minHeight: 24,

    '&::placeholder': { opacity: 1, color: theme.colors.grey99 },
  },
  inputMarginDense: {},
  inputMultiline: {
    paddingLeft: 12,
    paddingRight: 12,
  },
  inputTypeSearch: {},
  inputAdornedStart: {},
  inputAdornedEnd: {},
  inputHiddenLabel: {},
}));

const Input = React.forwardRef((props, ref) => {
  const { classes: classesProp, ...otherProps } = props;
  const classes = useStyles();

  return (
    <InputBase
      rowsMax={5}
      {...otherProps}
      classes={mergeClasses({ baseClasses: classes, newClasses: classesProp })}
      ref={ref}
    />
  );
});

Input.propTypes = {
  classes: PropTypes.object,
};

Input.defaultProps = {
  classes: {},
};

export default Input;
